import {Contract} from "../models/_models"
import moment from "moment";

export class ProbationContractStatusHelper {
    static calculate(contract: Contract) {
        var currentDate = moment(new Date());
        var probationContractEndDate = moment(contract?.probation_to);
        var leftDays = Math.ceil(probationContractEndDate.diff(currentDate, 'days', true));

        if (leftDays > 45) {
            if(contract?.status === 'expired')
            {
                return {days: leftDays, status: 'danger'}
            }
            else {
                return {days: leftDays, status: 'success'}
            }
        } else if (leftDays <= 45 && leftDays > 0) {
            if (contract?.status === 'expired') {
                return {days: leftDays, status: 'danger'}
            } else {
                return {days: leftDays, status: 'warning'}
            }
        } else {
            return {days: leftDays, status: 'danger'}
        }
    }
}
